module.exports = __webpack_public_path__ + "img/mobile-devices-blue-hue-original.446182ae.jpg";